import React, { FC } from 'react';
import { IconProps } from '.';

export const PaymentIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...sizing} {...props}>
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M20 6.303H4a1.03 1.03 0 0 0-1.03 1.03v9.334c0 .569.461 1.03 1.03 1.03h16a1.03 1.03 0 0 0 1.03-1.03V7.333A1.03 1.03 0 0 0 20 6.303Zm-16-.97a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7.333a2 2 0 0 0-2-2H4Z"
                clipRule="evenodd"
            />
            <path fill="url(#f39ce98e)" d="M2.97 8.303h18.06v2.303H2.97V8.303Z" />
            <path
                fill="currentColor"
                d="M9.758 14.182c0-.268.217-.485.484-.485h8.122a.485.485 0 1 1 0 .97h-8.122a.485.485 0 0 1-.484-.485Z"
            />
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.758 14.06a.545.545 0 1 0 1.09 0 .545.545 0 0 0-1.09 0Zm.545-1.15a1.151 1.151 0 1 0 0 2.302 1.151 1.151 0 0 0 0-2.303Z"
                clipRule="evenodd"
            />
            <defs>
                <linearGradient id="f39ce98e" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
